import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get, includes } from 'lodash';
import Image from '../Image/Image';
import medialFileShape from '../../shapes/medialFileShape';
import Button, { ButtonBlock } from '../Button/Button';

const defaultAvatar = require('../../../../img/avatars/male.png');
const notFoundAvatar = require('../../../../img/avatars/not-found.png');

export const Avatar = ({ src, onClick, canEdit, file, size, className, circle, rotateImg, rotationAngle, isRotateEnable = false }) => {


  const isDefaultImg = includes(src, 'male.png');

  const rotateImageHandler = (event) => {
    event.preventDefault();
    rotateImg();
  }

	return (
		<div className={classNames('avatar', className, { circle })} style={{ width: size, height: size }}>
			<Image
        className="portrait"
        src={Avatar.getImage(src, file)}
        style={{transform: `rotate(${rotationAngle}deg)`}}
        fallbackSrcSet={[notFoundAvatar]}
        width={size}
        height={size}
        circle={circle}
      />
			<div display-if={canEdit} className="edit" onClick={onClick}>
				{
					i18n.t("Edit", {
						context: 'button',
						ns: 'main'
					})
				}
			</div>
      {!isDefaultImg && isRotateEnable && canEdit &&
        <ButtonBlock className={ButtonBlock.center}>
          <Button
          key="rotate-file-button"
          onClick={rotateImageHandler}
          >
             <i className="fa fa-rotate-right" />
          </Button>
        </ButtonBlock>
      }
		</div>
	);
};

Avatar.getImage = (src, file) => {
	const fileContent = get(file, 'content');

	if (fileContent) {
		return Esk.Config.cdnPath(fileContent);
	}

	return src || defaultAvatar;
};

Avatar.className = 'avatar';


Avatar.propTypes = {
	src: PropTypes.string,
	onClick: PropTypes.func,
	canEdit: PropTypes.bool,
	file: PropTypes.shape(medialFileShape),
  size: PropTypes.number,
  className: PropTypes.string,
  circle: PropTypes.bool
};

Avatar.defaultProps = {
	canEdit: true,
  size: 100
};

export default Avatar;
